var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.5v11a.5.5 0 00.5.5H10a.5.5 0 00.5-.5v-5.4a.1.1 0 01.1-.1h2.8a.1.1 0 01.1.1v5.4a.5.5 0 00.5.5h5.5a.5.5 0 00.5-.5v-11a1 1 0 00-.4-.8l-7-5.25a1 1 0 00-1.2 0l-7 5.25a1 1 0 00-.4.8z",
    fill: "currentColor"
  })));
}
SvgHomeFilled.displayName = 'HomeFilled';
export default SvgHomeFilled;